<template>
  <div class="outer-body">
    <img :src="courseTypes[data.courseType].bgImage" class="bg-image" />
    <div class="body-content">
      <div class="content-center">
        <div :class="'bg-white content-with-bg relative content-item text-' + courseTypes[data.courseType].color">
          <div class="content-item-text">
            <h2 :class="'title-left-line border-left-' + courseTypes[data.courseType].color">岗位职责</h2>
            <div style="white-space: pre-wrap;">{{ courseTypes[data.courseType].describe }}</div>
          </div>
        </div>
        <div :class="'content-item flex-center bg-' + courseTypes[data.courseType].color">
          <div v-if="data.classesUrls && data.classesUrls.length > 0" class="title">{{ data.classesUrls[0].name }}</div>
          <img :src="courseTypes[data.courseType].icon" class="icon-image" />
          <a
            :class="'enter-btn text-' + courseTypes[data.courseType].color + ' shadow-' + courseTypes[data.courseType].color"
            target="_blank"
            :href="data.classesUrls[0].url"
          >进入学习</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Practice',
  components: {},
  props: {
    data: {
      type: Object,
      default: null,
      required: false
    },
    couserType: {
      type: String,
      default: '',
      required: false
    },
    assetsUrl: {
      type: String,
      default: 'https://static.51lss.com/o2ostu/assets/',
      required: false
    }
  },
  data() {
    return {
      list: [],
      courseTypes: {
        // 实训：出纳
        '6e7323f6f6a35ca250cfd2eceea63217': {
          color: 'orange',
          bgImage: this.assetsUrl + 'imgs/course/practice-image/bg-chuna.jpg',
          icon: this.assetsUrl + 'imgs/course/practice-image/icon-chuna.png',
          bgIcon: this.assetsUrl + 'imgs/course/practice-image/icon-bg-chuna.png',
          describe: `
      1、严格按照公司的财务制度、流程办理各项收支业务；\n
      2、及时准确登记收支账户现金、银行存款日记帐；\n
      3、做好资金盘点，账户明细、收支凭证与会计交接核对；\n
      4、负责平台流水核对，与客户和供应商对账；\n
      5、熟悉三大网银实训系统操作流程。`
        },
        //  实训：小规模会计岗位
        'f9d223ffa59902fab7fbc27258ff7a77': {
          color: 'dark-blue',
          bgImage: this.assetsUrl + 'imgs/course/practice-image/bg-xinsheqiyezhangshui.jpg',
          icon: this.assetsUrl + 'imgs/course/practice-image/icon-xinsheqiyezhangshui.png',
          bgIcon: this.assetsUrl + 'imgs/course/practice-image/icon-bg-xinsheqiyezhangshui.png',
          describe: `
              1、熟练办理新设企业注册登记；\n
              2、建立财务制度，审核原始凭证等经济业务；\n
              3、根据审核后的原始凭证进行账务处理；\n
              4、熟练完成日常开票及相关税务的申报和缴纳工作。`
        },
        // 实训：资金管理
        '456cfb8eb8535264912bcd6c0c779dce': {
          color: 'green',
          bgImage: this.assetsUrl + 'imgs/course/practice-image/bg-zijinguanli.jpg',
          icon: this.assetsUrl + 'imgs/course/practice-image/icon-zijinguanli.png',
          bgIcon: this.assetsUrl + 'imgs/course/practice-image/icon-bg-zijinguanli.png',
          describe: `    
      1、严格按照公司的财务制度办理各项审批申请；\n
      2、办理各项资金收付业务；\n
      3、熟悉微信、支付宝、网银的操作流程；\n
      4、做好资金计划，并进行资金执行情况分析；\n
      5、负责资金报表、资金管理与资金分析。`
        },
        //  实训：电算化全盘账
        e0e93204598e8d81c1e2a731135ae2e9: {
          color: 'purple',
          bgImage: this.assetsUrl + 'imgs/course/practice-image/bg-diansuanhua.jpg',
          icon: this.assetsUrl + 'imgs/course/practice-image/icon-diansuanhua.png',
          bgIcon: this.assetsUrl + 'imgs/course/practice-image/icon-bg-diansuanhua.png',
          describe: `
      1、负责账套建立、科目及期初设置；\n
      2、负责凭证的编制、审核；\n
      3、对账套数据进行分析；\n
      4、做好日常数据备份。`
        },
        // 工业全盘账
        'fe5ce168c81cb656e1e6119b1a3de8d7': {
          color: 'blue',
          bgImage: this.assetsUrl + 'imgs/course/practice-image/bg-gongyequanpanzhang.jpg',
          icon: this.assetsUrl + 'imgs/course/practice-image/icon-gongye.png',
          bgIcon: this.assetsUrl + 'imgs/course/practice-image/icon-bg-gongye.png',
          describe: `
      1、熟悉工业企业流程及企业财务制度；\n
      2、做好日常业务的账务处理；\n
      3、月末能够准确地进行成本核算；\n
      4、编制相应的会计报表。`
        },
        //  纳税岗位实训
        '5aa74b04f8daa50f8f1e7aa30f6f979c': {
          color: 'red',
          bgImage: this.assetsUrl + 'imgs/course/practice-image/bg-nashuigangwei.jpg',
          icon: this.assetsUrl + 'imgs/course/practice-image/icon-nashui.png',
          bgIcon: this.assetsUrl + 'imgs/course/practice-image/icon-bg-nashui.png',
          describe: `
      1、负责办理发票的领购、使用和保管；\n
      2、编制各种报表，按时进行纳税申报与缴纳\n
      3、管理日常税收事务，协助监督、检查公司税务法规执行情况；\n
      4、对公司税负情况进行综合分析和筹划，提出合理化建议。`
        },
        // 实训：手工全盘账
        '6b20f8d3812e3a697c02498a08c8cd05': {
          color: 'light-orange',
          bgImage: this.assetsUrl + 'imgs/course/practice-image/bg-shougongquanpanzhang.jpg',
          icon: this.assetsUrl + 'imgs/course/practice-image/icon-shougongzhang.png',
          bgIcon: this.assetsUrl + 'imgs/course/practice-image/icon-bg-shougongzhang.png',
          describe: `
      1、审核合同、原始凭证等经济业务凭证；\n
      2、及时进行账务处理，编制记账凭证；\n
      3、期末进行对账和结账，编制财务报表；\n
      4、掌握日常开票、纳税申报，以及合理的税收筹划；\n
      5、进行会计档案管理及相关的制度建设等。`
        }
      }
    }
  },
  created() {
    console.log(this.courseTypes[this.data.courseType].color, this.data.courseType)
  },
  methods: {}
}
</script>
<style scoped lang="less">
.outer-body {
  position: relative;
  width: 100%;
  height: 100%;
}
.body-content {
  position: absolute;
  top: 0;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.content-center {
  display: flex;
  width: 60%;
  min-height: 30%;
  align-items: stretch;
  min-width: 600px;
  .content-item {
    flex: 1;
    padding: 27px;
  }
}
.title {
  font-size: 20px;
}
.text-center {
  text-align: center;
}
.enter-btn {
  width: 80%;
  max-width: 200px;
  background: #fff;
  text-align: center;
  border: 0;
  padding: 6px 0;
  border-radius: 2px;
}
.icon-image {
  width: 72px;
  height: 72px;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.line-height-2 {
  line-height: 2;
  z-index: 2;
  margin-bottom: 10px;
}
.bg-white {
  background-color: #ffffff;
}
.title-left-line {
  padding-left: 6px;
  font-size: 16px;
  margin-bottom: 28px;
  margin-top: 20px;
  z-index: 2;
}
.relative {
  position: relative;
}
.content-with-bg {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 30%;
}

// 橘色
.bg-orange {
  background-image: linear-gradient(#ff6100, #ff8940);
  color: #ffffff;
}
.text-orange {
  color: #ff6100;
}
.shadow-orange {
  box-shadow: 0px 2px 2px 0px #b04300;
}
.border-left-orange {
  color: #ff6100;
  border-left: 3px solid #ff6100;
}

// 蓝色
.text-blue {
  color: #1e78e5;
}
.bg-blue {
  background-image: linear-gradient(#4d95eb, #1e78e5);
  color: #ffffff;
}
.border-left-blue {
  color: #1e78e5;
  border-left: 3px solid #1e78e5;
}
.shadow-blue {
  box-shadow: 0px 2px 2px 0px #006c6a;
}

// 深蓝色
.text-dark-blue {
  color: #2951a3;
}
.bg-dark-blue {
  background-image: linear-gradient(#417aef, #2454b5);
  color: #ffffff;
}
.border-left-dark-blue {
  color: #2951a3;
  border-left: 3px solid #2951a3;
}
.shadow-dark-blue {
  box-shadow: 0px 2px 2px 0px #2951a3;
}

// 绿色
.text-green {
  color: #02903a;
}
.bg-green {
  background-image: linear-gradient(#27f277, #0aa447);
  color: #ffffff;
}
.border-left-green {
  color: #02903a;
  border-left: 3px solid #02903a;
}
.shadow-green {
  box-shadow: 0px 2px 2px 0px #00732e;
}

// 红色
.text-red {
  color: #e51e3f;
}
.bg-red {
  background-image: linear-gradient(#eb4d60, #e51e3f);
  color: #ffffff;
}
.border-left-red {
  color: #e51e3f;
  border-left: 3px solid #e51e3f;
}
.shadow-red {
  box-shadow: 0px 2px 2px 0px #eb4d60;
}

// 浅橘色
.text-light-orange {
  color: #ff7800;
}
.bg-light-orange {
  background-image: linear-gradient(#ff992b, #ff7800);
  color: #ffffff;
}
.border-left-light-orange {
  color: #ff7800;
  border-left: 3px solid #ff7800;
}
.shadow-light-orange {
  box-shadow: 0px 2px 2px 0px #ff7800;
}

// 紫色
.text-purple {
  color: #6c33dd;
}
.bg-purple {
  background-image: linear-gradient(#8a56eb, #6c33dd);
  color: #ffffff;
}
.border-left-purple {
  color: #6c33dd;
  border-left: 3px solid #6c33dd;
}
.shadow-purple {
  box-shadow: 0px 2px 2px 0px #6c33dd;
}
</style>
